var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"framed-table"},[_c('div',{staticClass:"framed-table__scroll"},[_c('table',{staticClass:"table framed-table__table",class:{ 'table-striped': _vm.striped }},[_vm._t("default")],2)]),_vm._v(" "),(_vm.$slots.footer)?_c('div',{staticClass:"framed-table__footer"},[_vm._t("footer")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-944db222","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/pages/components/default/framedTable.vue
// module id = 1034
// module chunks = 0